export enum FxType {
    SPOT = 'SPOT',
    FORWARD = 'FORWARD'
}